<template>
  <div>
    <!--LISTAR EMAILS-->
    <ed-modal
      :title="'Item Lote ' + this.parent.formData.lote"
      :modal="showFormList"
      width="98%"
    >
      <div slot="modal-content">
        <!-- <ed-table
          :tableHead="tableHead"
          :tableData="tableData"
          :loadingTable="loadingTable"
        /> -->
        <eSocial v-if="parent.formData.lote" :key="formData.id+'-'+(showForm ? 1 : 0)" :layout="parent.formData.layout" :lote="parent.formData.lote" :avulso="parent.formData.avulso ? parent.formData.avulso : 0"></eSocial>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import EdTable from "common/table";
import EdModal from "common/modal";
import EdForm from "common/form";
import Rest from "common/rest";
import eSocial from 'appsWeb/esocial/index';

export default {
  name: "esocial-lotes-email",
  mixins: [Rest],
  components: { EdTable, EdModal, EdForm,eSocial},
  props: {
    showForm: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  inject: ["formData", "parent"],
  watch: {
    showForm() {
      this.showFormList = !this.showFormList;
      this.getEsocialLotes();
    },
  },
  data() {
    return {
      tableHead: [
        {
          key: "funcionario",
          label: "Funcionário",
        },
      ],
      tableData: [],
      formItems: [],
      showFormList: false,
      loadingTable: false,
    };
  },

  created() {},

  mounted() {},

  methods: {

    getEsocialLotes() {
      /*
      this.loadingTable = true;

      this.get("/esocial/lotes/" + this.parent.formData.id).then((result) => {
        result = result[0];

        console.log("result", result);

        this.loadingTable = false;
        this.tableData = [];

        let items = Object.assign(result.data.items,{})

        console.log("items", items);
            
        if (result.status == 200) {
          items.forEach((element) => {

            let descricao = "";

            if ((element.layout == "S-2220")) {
              descricao = " Consulta " + element.id_con;
            } else if (
              (element.layout ==
                "S-2240" &&
                element.ltcat_funcionario &&
                element.ltcat_funcionario.ghe)
            ) {
              descricao =
                " GHE " +
                element.ltcat_funcionario.ghe.ghe +
                " (" +
                element.ltcat_funcionario.ghe.descricao +
                ")";
            }

            var item = {
              funcionario: element.funcionario.nome + "<b>"+descricao+"</b>",
              _data: element,
              buttons: [],
              options: {},
            };

            this.tableData.push(item);
          });
        }
      });
      */
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?694ed952